// Responsive modal styles
export const getModalStyles = (isMobile) => ({
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: isMobile ? 'flex-end' : 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: isMobile ? 0 : '20px'
  },
  content: {
    background: 'white',
    borderRadius: isMobile ? '12px 12px 0 0' : '8px',
    width: isMobile ? '100%' : '90%',
    maxWidth: isMobile ? '100%' : '700px',
    maxHeight: isMobile ? '90vh' : '85vh',
    overflowY: 'auto',
    padding: isMobile ? '20px' : '30px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
  },
  header: {
    padding: isMobile ? '15px 20px' : '25px',
    borderBottom: '2px solid #ecf0f1',
    background: '#f8f9fa',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: isMobile ? '12px 12px 0 0' : '12px 12px 0 0'
  }
});

// Responsive card grid styles
export const getCardGridStyles = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(350px, 1fr))',
  gap: isMobile ? '12px' : '15px'
});

// Responsive button styles
export const getButtonStyles = (isMobile, baseStyle = {}) => ({
  ...baseStyle,
  padding: isMobile ? '6px 12px' : '8px 16px',
  fontSize: isMobile ? '12px' : '14px'
});

// Responsive table container styles
export const getTableContainerStyles = (isMobile) => ({
  overflowX: isMobile ? 'auto' : 'visible',
  width: '100%',
  WebkitOverflowScrolling: 'touch' // Smooth scrolling on iOS
});
